import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';
import { PageLoginComponent } from './login/login.component';
// Page Layouts
import { PageLayoutFullscreenComponent } from './page-layouts/fullscreen/fullscreen.component';


const AppRoutes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'app', component: LayoutComponent },
    { path: 'login', component: PageLoginComponent },
    { path: 'extra', loadChildren: './extra-pages/extra-pages.module#ExtraPagesModule' },
    { path: 'fullscreen', component: PageLayoutFullscreenComponent },
    { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, {useHash: true});



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app-routing.module.ts